import { Topbar } from '../../components/Topbar/Topbar';
import { Card, Container } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import './Tootors.scss';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';
import { useEffect, useState } from 'react';
import { useGaming } from '../../../contexts/GamingContext';

const TootorsComponent = () => {
  const { authors, userDataFmt } = useFirebase();
  const { track } = useGaming();
  const history = useHistory();
  const { t } = useTranslation();

  const [isOdontoiatra, setIsOdontoiatra] = useState(false);
  useEffect(() => {
    if (!userDataFmt) return;
    const myCategory = userDataFmt.profile?.formData?.categoriaProfessionale;
    setIsOdontoiatra(myCategory == 'odontoiatra');
  }, []);

  if (!authors?.length) return <FullscreenLoader />;

  return (
    <>
      <Title>{t('tootors.labels.iNostriToot')}</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <div className={'display-4 mb-5 text-center'}>{t('tootors.labels.iNostriToot')}</div>
        <div className={'tootor-cards-container justify-content-start justify-content-sm-center'}>
          {authors.map((author) => (
            <Card
              bg={'dark'}
              className={'tootor-card'}
              key={author.id}
              onClick={() => {
                track('TOOTOR_CLICK', { authorId: author.id });
                if (author.seriesId && isOdontoiatra) {
                  history.push(`/series/${author.seriesId}`);
                } else {
                  history.push({
                    pathname: '/search',
                    search: `q=${encodeURIComponent(author.name)}`,
                  });
                }
              }}
            >
              <div className={'d-flex align-items-center'}>
                <div className={'authors-list-photo'}>
                  <img src={author.photo} alt={null} loading={'lazy'} />
                </div>
                <div className={'d-flex flex-column ml-2 mr-3'}>
                  <span className={'h5 mb-0'}>{author.name}</span>
                  {!!author.description && <small className={'text-muted'}>{author.description}</small>}
                </div>
              </div>
              {/*<Card.Footer>
              <div className="d-flex justify-content-end">
                <Button size={'sm'} variant={'primary'}>
                  Vai ai video
                </Button>
              </div>
            </Card.Footer>*/}
            </Card>
          ))}
        </div>
      </Container>

      <Footer />
    </>
  );
};

export default TootorsComponent;
